import React from "react";
import { useNavigate } from "react-router-dom";
import "./Terms.css";

export default function Terms() {
  const navigate = useNavigate();

  return (
    <div className="terms-container">
      <button className="terms-back-btn" onClick={() => navigate(-1)}>
        ← Back
      </button>

      <div className="terms-content">
        <h1>📜 TERMS & CONDITIONS</h1>

        <div className="terms-section">
          <h2>1. Registration & Entry</h2>
          <ul>
            <li>Entry is strictly allowed only with a valid ticket confirmation.</li>
            <li>Tickets once booked are non-refundable (unless the event is canceled by organizers).</li>
          </ul>
        </div>

        <div className="terms-separator"></div>

        <div className="terms-section">
          <h2>2. Cancellation Policy</h2>
          <ul>
            <li>No refunds will be issued for no-shows.</li>
            <li>In case of unavoidable circumstances, the organizer reserves the right to reschedule the event.</li>
          </ul>
        </div>

        <div className="terms-separator"></div>

        <div className="terms-section">
          <h2>3. Event Changes</h2>
          <p>The organizer reserves the right to change:</p>
          <ul>
            <li>Venue</li>
            <li>Timing</li>
            <li>Schedule</li>
          </ul>
          <p className="terms-note">Without prior notice due to unforeseen circumstances.</p>
        </div>

        <div className="terms-separator"></div>

        <div className="terms-section">
          <h2>4. Code of Conduct</h2>
          <ul>
            <li>Attendees are expected to maintain professional behavior.</li>
            <li>Any misconduct may result in removal from the event without refund.</li>
          </ul>
        </div>

        <div className="terms-separator"></div>

        <div className="terms-section">
          <h2>5. Recording & Media</h2>
          <ul>
            <li>Photography and videography may be conducted during the event.</li>
            <li>By attending, you consent to your image being used for promotional purposes.</li>
          </ul>
        </div>

        <div className="terms-separator"></div>

        <div className="terms-section">
          <h2>6. Intellectual Property</h2>
          <ul>
            <li>All techniques, content, and materials presented are the intellectual property of the artist.</li>
            <li>Recording, copying, or redistributing content without permission is strictly prohibited.</li>
          </ul>
        </div>

        <div className="terms-separator"></div>

        <div className="terms-section">
          <h2>7. Liability</h2>
          <p>The organizer is not responsible for:</p>
          <ul>
            <li>Personal belongings</li>
            <li>Travel delays</li>
            <li>Any unforeseen personal loss</li>
          </ul>
        </div>

        <div className="terms-separator"></div>

        <div className="terms-section">
          <h2>8. Force Majeure</h2>
          <p>The event may be postponed or canceled due to circumstances beyond control (natural disasters, government restrictions, etc.).</p>
        </div>

        <div className="terms-footer-note">
          By booking tickets, you acknowledge and agree to these Terms & Conditions.
        </div>
      </div>
    </div>
  );
}
